import { render, staticRenderFns } from "./SalasEdicao.vue?vue&type=template&id=9c78df10"
import script from "./SalasEdicao.vue?vue&type=script&lang=js"
export * from "./SalasEdicao.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports